export class MPAPolicyApprovalProgress {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaPolicyId",
            "baseName": "mpaPolicyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "currentApprovals",
            "baseName": "currentApprovals",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAPolicyApprovalProgress.attributeTypeMap;
    }
    constructor() {
    }
}
